async function getImageDimensions(imageUrl) {
  const img = new Image()
  img.src = imageUrl

  await new Promise((resolve, reject) => {
    img.onload = resolve
    img.onerror = reject
  })

  return {
    width: img.naturalWidth,
    height: img.naturalHeight
  }
}

export default getImageDimensions
